import { ConsoleLoggerFactory, ConnectError, parseResponse } from '@square/ember-rpc-client/utils';
import { appHost } from '@square/environment-utils/app-urls';
import environment from '@square/environment-utils/environment';
import { getUrlFlag } from '@square/dashboard-utilities/utils/window';
import { AuthzEnginesManager } from '@square/authz-engines';
const logrpc = Boolean(getUrlFlag('logrpc', location));
const env = environment();
const loggingEnabled = env.isDevelopment || env.isStaging || logrpc;
export function getUrlHostCallback(useSameHost = false) {
  return (_, url) => apiHostUrl(_, url, useSameHost);
}
export function apiHostUrl(_, url, useSameHost = false) {
  return `//${appHost(location.host, {
    useSameHost
  })}${url}`;
}

// Default RPC implementation used by RPC clients in the @banking/api package.
export default function rpc(urlForMethod, headers, setTraceId = true) {
  return AuthzEnginesManager.emberRpcV1({
    urlForMethod,
    loggerFactory: new ConsoleLoggerFactory(loggingEnabled),
    errorDeserializer: ConnectError.fromResponse,
    additionalHeaders: headers,
    responseParser: parseResponse,
    sendSpeleoTraceId: setTraceId
  });
}